import { render } from "./marketplacefooter.vue?vue&type=template&id=50f18af4"
import script from "./marketplacefooter.vue?vue&type=script&lang=js"
export * from "./marketplacefooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__